<template>
  <v-container>
    <v-flex xs12 class="background">
      <v-toolbar height="56" color="primary">
        <v-toolbar-title id="idCabecalhoJanela" class="subheading white--text">
          Veículos
        </v-toolbar-title>
      </v-toolbar>
      <v-layout pa-5>
        <v-flex row wrap>
          COTAÇÃO
          <p>{{ formatarNumeroCotacao(id) }}</p>
        </v-flex>
        <v-flex row wrap>
          APÓLICE
          <p>{{ formatarNumeroApolice(apoliceNumeroProposta) }}</p>
        </v-flex>
        <v-flex>
          CNPJ
          <p>{{ formatarCnpj(proponenteCnpj) }}</p>
        </v-flex>
        <v-flex
          >RAZÃO SOCIAL
          <p>{{ proponenteRazaoSocial }}</p>
        </v-flex>
        <v-flex
          >ÍTENS
          <p>{{ quantidadeItens }}</p>
        </v-flex>
        <v-flex>
          VIGÊNCIA
          <p>{{ formatarData(dateInicio) }}</p>
        </v-flex>
        <v-flex>
          <br />
          <p>{{ formatarData(dateFim) }}</p>
        </v-flex>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
      </v-layout>
    </v-flex>
    <v-container pa-5 class="background data-table">
      <v-card elevation="0">
        <v-card-title>
          <v-flex xs12 sm11 md6 lg4>
            <transition name="fade">
              <v-flex xs1 v-if="!filtro.pesquisa.opened">
                <v-btn
                  v-if="!filtro.pesquisa.opened"
                  @click="filtroFunctions().abrirFiltroPesquisa()"
                  color="primary"
                  round
                  outline
                  icon
                  ><v-icon>search</v-icon></v-btn
                >
              </v-flex>
              <v-flex v-else>
                <v-text-field
                  v-model="filtro.pesquisa.conteudo"
                  prepend-icon="search"
                  @click:prepend="filtroFunctions().fecharFiltroPesquisa()"
                  @blur="filtroFunctions().fecharFiltroPesquisa()"
                  label="Busca"
                  autofocus
                  clearable
                ></v-text-field>
              </v-flex>
            </transition>
          </v-flex>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>

          <v-btn
            v-if="copiaParcial && !selected.length"
            color="primary"
            round
            dark
            @click="dialogImportarPlanilha = true"
            >Importar Planilha de Itens</v-btn
          >

          <v-btn
            v-if="!selected.length"
            color="primary"
            round
            dark
            @click="dialog = true"
            :disabled="disabilitar"
            >Adicionar Ítem</v-btn
          >

          <v-btn
            @click="filtrarErros = !filtrarErros"
            :class="filtrarErros ? 'activeError' : 'error'"
            v-if="numeroErros && !selected.length"
            round
            ><v-icon class="mr-1">error</v-icon
            >{{ `${numeroErros} ${numeroErros === 1 ? "Erro" : "Erros"}` }}
          </v-btn>

          <v-btn
            v-if="mostrarBotaoReavaliar"
            @click="reavaliarItem(selected)"
            color="primary"
            round
          >
            Reavaliar Ítem
          </v-btn>
          <v-btn
            @click="deletarItens"
            v-if="selected.length >= 1"
            color="error"
            round
          >
            {{
              selected.length === 1 ? "Excluir Ítem" : "Excluir Ítens"
            }}</v-btn
          >
        </v-card-title>
      </v-card>
      <template>
        <div class="table-width">
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="errosFiltrados"
            :search="filtro.pesquisa.conteudo"
            :pagination.sync="pagination"
            :select-all="!camposDisabled"
            :rows-per-page-items="[10, 25, 50, 100, 150, 200, 300, 400, 500]"
            rows-per-page-text="Itens por página"
            item-key="item"
            class="elevation-0 text-align-center"
          >
            <template v-slot:items="props">
              <td
                v-if="!camposDisabled"
                :active="props.selected"
                @click="props.selected = !props.selected"
              >
                <v-checkbox
                  class="checkbox"
                  color="primary"
                  :input-value="props.selected"
                  primary
                  hide-details
                  :disabled="camposDisabled"
                ></v-checkbox>
              </td>
              <td class="pa-4 themeGrey--text">
                {{ formatarNumeroItem(props.item.item) }}
              </td>
              <td class="pa-0 item-faltante">
                <v-tooltip
                  v-if="props.item.erro"
                  right
                  color="error"
                  max-width="350px"
                >
                  <template v-slot:activator="{ on }">
                    <span class="error--text" v-on="on">⬤</span>
                  </template>
                  <span
                    >Não foi possivel avaliar este item devido a um ou mais
                    erros nos dados informados. Consulte a FIPE, corrija o(s)
                    erro(s) direto na linha e clique em "Reavaliar Item" para
                    reprocessar os dados.</span
                  >
                </v-tooltip>
              </td>
              <td class="">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.placa"
                  lazy
                  large
                  persistent
                  @save="saveErro(props.item)"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                  >{{ props.item.placa
                  }}<template v-slot:input>
                    <v-text-field
                      v-model="props.item.placa"
                      label="Editar"
                      single-line
                      :rules="regras.notNull"
                    ></v-text-field>
                  </template>
                </v-edit-dialog>

                <span class="themeGrey--text" v-else>{{
                  props.item.placa
                }}</span>
              </td>
              <td class="">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.chassi"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                  >{{ props.item.chassi
                  }}<template v-slot:input>
                    <v-text-field
                      v-model="props.item.chassi"
                      label="Editar"
                      single-line
                      :rules="regras.notNull"
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>{{
                  props.item.chassi
                }}</span>
              </td>
              <td class="">
                <template v-if="!props.item.fipe || props.item.erro">
                  <v-btn
                    @click="
                      exibeFipe(props.item)
                    "
                    class="error"
                    round
                  >
                    Selecionar
                  </v-btn>
                </template>
                <template v-else>
                  <v-edit-dialog
                    class="item-color"
                    :return-value.sync="props.item.fipe"
                    lazy
                    large
                    persistent
                    @save="saveErro(props.item)"
                    @cancel="cancel"
                    @open="open"
                    @close="close"
                    save-text="Salvar"
                    cancel-text="Cancelar"
                    v-if="!camposDisabled"
                  >
                    {{ props.item.fipe }}
                    <template v-slot:input>
                      <v-text-field
                        v-model="props.item.fipe"
                        label="Editar"
                        single-line
                        :rules="regras.notNull"
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                  <span class="themeGrey--text" v-else>{{
                    props.item.fipe
                  }}</span>
                </template>
              </td>
              <td class="themeGrey--text">
                <v-edit-dialog
                  v-if="!camposDisabled"
                  class="item-color"
                  :return-value.sync="props.item.marca"
                  lazy
                  large
                  persistent
                  @save="saveErro(props.item)"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  >{{ props.item.marca
                  }}<template v-slot:input>
                    <v-text-field
                      v-model="props.item.marca"
                      label="Editar"
                      single-line
                      :rules="regras.notNull"
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>
                  {{ props.item.marca }}
                </span>
              </td>
              <td class="themeGrey--text">
                <v-edit-dialog
                  v-if="!camposDisabled"
                  class="item-color"
                  :return-value.sync="props.item.modelo"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  >{{ props.item.modelo
                  }}<template v-slot:input>
                    <v-text-field
                      v-model="props.item.modelo"
                      label="Editar"
                      single-line
                      :rules="regras.notNull"
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>
                  {{ props.item.modelo }}
                </span>
              </td>
              <td class="themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.tipoVeiculo"
                  lazy
                  large
                  persistent
                  @save="saveErro(props.item)"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                  >{{
                    buscarTitulo(props.item.tipoVeiculo, campos.tipoVeiculoList)
                  }}
                  <template v-slot:input>
                    <v-select
                      :items="campos.tipoVeiculoList"
                      v-model="props.item.tipoVeiculo.id"
                      item-text="titulo"
                      item-value="id"
                      label="Editar"
                      :rules="regras.notNull"
                    ></v-select>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>
                  {{
                    buscarTitulo(props.item.tipoVeiculo, campos.tipoVeiculoList)
                  }}
                </span>
              </td>
              <td class="themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.catVeiculo"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                >
                  <span
                    :class="{
                      errorTaxa: erros[props.item.item].catVeiculo.erro,
                    }"
                    >{{
                      buscarTitulo(props.item.catVeiculo, campos.catVeiculoList)
                    }}</span
                  >
                  <template v-slot:input>
                    <v-select
                      :items="campos.catVeiculoList"
                      v-model="props.item.catVeiculo"
                      item-text="titulo"
                      :item-value="(item) => item"
                      label="Editar"
                      :rules="regras.notNull"
                      :value-comparator="comparador"
                    ></v-select>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>
                  {{
                    buscarTitulo(props.item.catVeiculo, campos.catVeiculoList)
                  }}
                </span>
              </td>
              <td class="themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.anoFab"
                  lazy
                  large
                  persistent
                  @save="saveErro(props.item)"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                  >{{ props.item.anoFab
                  }}<template v-slot:input>
                    <v-text-field
                      v-model="props.item.anoFab"
                      label="Editar"
                      single-line
                      :rules="regras.notNull"
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>
                  {{ props.item.anoFab }}
                </span>
              </td>
              <td class="themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.anoMod"
                  lazy
                  large
                  persistent
                  @save="saveErro(props.item)"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                  >{{ props.item.anoMod
                  }}<template v-slot:input>
                    <v-text-field
                      v-model="props.item.anoMod"
                      label="Editar"
                      single-line
                      :rules="regras.notNull"
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>
                  {{ props.item.anoMod }}
                </span>
              </td>
              <td class="themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.ufPernoite"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                >
                  <span
                    :class="{
                      errorTaxa: erros[props.item.item].ufPernoite.erro,
                    }"
                    >{{
                      buscarTitulo(props.item.ufPernoite, campos.ufPernoiteList)
                    }}</span
                  >
                  <template v-slot:input>
                    <v-select
                      :items="campos.ufPernoiteList"
                      v-model="props.item.ufPernoite"
                      item-text="titulo"
                      :item-value="(item) => item"
                      label="Editar"
                      :rules="regras.notNull"
                      :value-comparator="comparador"
                    ></v-select>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>
                  {{
                    buscarTitulo(props.item.ufPernoite, campos.ufPernoiteList)
                  }}
                </span>
              </td>
              <td class="themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.usoDoVeiculo"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                >
                  <span
                    :class="{
                      errorTaxa: erros[props.item.item].usoDoVeiculo.erro,
                    }"
                    >{{
                      buscarTitulo(
                        props.item.usoDoVeiculo,
                        campos.usoDoVeiculoList
                      )
                    }}</span
                  >
                  <template v-slot:input>
                    <v-select
                      :items="campos.usoDoVeiculoList"
                      v-model="props.item.usoDoVeiculo"
                      item-text="titulo"
                      :item-value="(item) => item"
                      label="Editar"
                      :rules="regras.notNull"
                      :value-comparator="comparador"
                    ></v-select>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>
                  {{
                    buscarTitulo(
                      props.item.usoDoVeiculo,
                      campos.usoDoVeiculoList
                    )
                  }}
                </span>
              </td>
              <td class="themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.propriedadeRegistroDoCrlv"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                >
                  <span
                    :class="{
                      errorTaxa:
                        erros[props.item.item].propriedadeRegistroDoCrlv.erro,
                    }"
                    >{{
                      buscarTitulo(
                        props.item.propriedadeRegistroDoCrlv,
                        campos.propriedadeRegistroDoCrlvList
                      )
                    }}</span
                  >
                  <template v-slot:input>
                    <v-select
                      :items="campos.propriedadeRegistroDoCrlvList"
                      v-model="props.item.propriedadeRegistroDoCrlv"
                      item-text="titulo"
                      :item-value="(item) => item"
                      label="Editar"
                      :rules="regras.notNull"
                      :value-comparator="comparador"
                    ></v-select>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>
                  {{
                    buscarTitulo(
                      props.item.propriedadeRegistroDoCrlv,
                      campos.propriedadeRegistroDoCrlvList
                    )
                  }}
                </span>
              </td>
              <td class="themeGrey--text">
                {{ props.item.proprietario }}
              </td>
              <td class="themeGrey--text">
                <v-edit-dialog
                  v-if="!camposDisabled"
                  class="item-color"
                  :return-value.sync="props.item.cpfCnpj"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  >{{ props.item.cpfCnpj
                  }}<template v-slot:input>
                    <v-text-field
                      v-model="props.item.cpfCnpj"
                      label="Editar"
                      single-line
                      :rules="regras.notNull"
                    ></v-text-field>
                  </template>
                </v-edit-dialog>

                <span class="themeGrey--text" v-else>
                  {{ props.item.cpfCnpj }}
                </span>

              </td>
              <td class="themeGrey--text">
                <v-edit-dialog
                  v-if="!camposDisabled"
                  class="item-color"
                  :return-value.sync="props.item.nomeSocial"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  >{{ props.item.nomeSocial
                  }}<template v-slot:input>
                    <v-text-field
                      v-model="props.item.nomeSocial"
                      label="Editar"
                      single-line
                      :rules="regras.notNull"
                    ></v-text-field>
                  </template>
                </v-edit-dialog>

                <span class="themeGrey--text" v-else>
                  {{ props.item.nomeSocial }}
                </span>

              </td>
              <td class="themeGrey--text">
                {{ traduzValor(props.item.chassiRemarcado) }}
              </td>
              <td class="themeGrey--text">
                {{ traduzValor(props.item.zeroKm) }}
              </td>

              <td class="text-xs-center themeGrey--text">
                {{ formatarData(props.item.saidaDaConcessionaria) }}
              </td>
              <td class="themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.quantPassageiro"
                  lazy
                  large
                  persistent
                  @save="saveErro(props.item)"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                >
                  {{ props.item.quantPassageiro}}
                  <template v-slot:input>
                    <v-text-field
                      v-model="props.item.quantPassageiro"
                      label="Editar"
                      single-line
                      :rules="regras.notNull"
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>
                  {{Object.keys(chassiQtdPassageiros).length !== 0 ? chassiQtdPassageiros[props.item.chassi] : props.item.quantPassageiro }}
                </span>
              </td>
              <td class="themeGrey--text">
                <v-edit-dialog
                  class="item-color"
                  :return-value.sync="props.item.codigoSistemaRastreamento"
                  lazy
                  large
                  persistent
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                  save-text="Salvar"
                  cancel-text="Cancelar"
                  v-if="!camposDisabled"
                >
                  <span
                    :class="{
                      errorTaxa: erros[props.item.item].codigoSistemaRastreamento.erro,
                    }"
                    >{{
                      buscarTitulo(props.item.codigoSistemaRastreamento, campos.codigoSistemaRastreamentoList)
                    }}</span
                  >
                  <template v-slot:input>
                    <v-select
                      :items="campos.codigoSistemaRastreamentoList"
                      v-model="props.item.codigoSistemaRastreamento"
                      item-text="titulo"
                      :item-value="(item) => item"
                      label="Editar"
                      :rules="regras.notNull"
                      :value-comparator="comparador"
                    ></v-select>
                  </template>
                </v-edit-dialog>
                <span class="themeGrey--text" v-else>
                  {{
                    buscarTitulo(props.item.codigoSistemaRastreamento, campos.codigoSistemaRastreamentoList)
                  }}
                </span>
              </td>
            </template>
            <template v-slot:pageText="props">
              {{ props.pageStart }} - {{ props.pageStop }} de
              {{ props.itemsLength }}
            </template>
            <template v-slot:no-results>
              <v-alert :value="true" color="error" icon="warning">
                Sua pesquisa não foi encontrada.
              </v-alert>
            </template>
          </v-data-table>
        </div>
      </template>
      <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
        {{ snackText }}
        <v-btn flat @click="snack = false">Fechar</v-btn>
      </v-snackbar>
    </v-container>
    <v-layout pt-5 align-center>
      <v-spacer></v-spacer>
      <BotaoRecusarCotacao :idApolice="idApolice" :idPropostaStatus="idPropostaStatus" variant="footer" class="mr-3" />
      <v-btn color="primary" @click="voltar" outline class="mr-3"> Voltar </v-btn>
      <v-btn
        class="button-custom"
        :disabled="copiaParcialSemItens"
        @click="
          numeroErros > 0 || !validaColunas()
            ? (dialogConfirmacao = true)
            : proximo()
        "
        flat
      >
        Próximo
      </v-btn>
    </v-layout>
    <template>
      <v-layout row justify-center>
        <v-dialog
          v-model="dialogImportarPlanilha"
          max-width="800px"
        >
          <ModalImportarPlanilhaItens
            v-if="dialogImportarPlanilha"
            @importar="importarPlanilhaItens"
            @cancelar="dialogImportarPlanilha = false"
          />
        </v-dialog>
      </v-layout>
    </template>
    <template>
      <v-layout row justify-center>
        <v-dialog persistent v-model="dialogAvaliando" max-width="800px">
          <v-card class="dialog">
            <v-card-title class="primary">
              <span class="headline">A ALIANDO ITENS</span>
            </v-card-title>
            <v-card-text class="py-5 px-4">
              <div grid-list-md>
                <v-layout wrap>
                  <v-flex align-center d-flex xs12>
                    <span>
                      Por favor, aguarde o processamento. Isso pode levar alguns
                      minutos
                    </span>
                  </v-flex>
                  <v-flex align-center d-flex xs12>
                    <v-progress-linear
                      heigth="2px"
                      indeterminate
                      color="primary"
                    ></v-progress-linear>
                  </v-flex>
                </v-layout>
              </div>
            </v-card-text>

            <v-card-actions class="px-4 pb-5">
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="dialogAvaliando = false"
                >CANCELAR
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </template>

    <template>
      <v-layout row justify-center>
        <v-dialog persistent v-model="dialogConfirmacao" max-width="700px">
          <v-card class="dialog">
            <v-card-title class="primary">
              <span class="headline">ATENÇÃO</span>
            </v-card-title>
            <v-card-text class="py-5 px-4">
              <div grid-list-md>
                <v-layout wrap>
                  <v-flex align-center d-flex xs12 sm8>
                    <span class="text-permanecer">
                      Existem ítens com erros que ainda não foram corrigidos.
                      <br />
                      Tem certeza de que deseja ir para a próxima etapa sem
                      corrigi-los? <br />
                      Os ítens com erros não serão incluídos na apólice.
                    </span>
                  </v-flex>
                </v-layout>
              </div>
            </v-card-text>

            <v-card-actions class="px-4 pb-5">
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="proximo">
                Ignorar os Erros
              </v-btn>

              <v-btn
                class="button-permanecer"
                flat
                @click="dialogConfirmacao = false"
                >Permanecer nesta etapa
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </template>

    <template>
      <v-layout row justify-center>
        <v-dialog v-model="dialog" hide-overlay fullscreen>
          <AdicionarItemModal
            v-if="dialog"
            @add="dadosPlanilha.push($event), (dialog = false)"
            :item="proximoIndice"
            :dialog="dialog"
            @fechar="dialog = false"
            :campos="campos"
          />
        </v-dialog>
      </v-layout>
    </template>

    <template>
      <v-layout row justify-center>
        <v-dialog
          v-model="dialogFipe"
          hide-overlay
          persistent
          max-width="600px"
        >
          <TabelaFipeModal
            v-if="selecionarModelo"
            :listaVeiculo="listaVeiculo"
            :infoVeiculo="infoVeiculo"
            @fechar="dialogFipe = false"
            @salvar="preencherDadosVeiculo"
            @buscarFipe="buscarFipes"
          />
        </v-dialog>
      </v-layout>
    </template>

  </v-container>
</template>

<script>
import {VMoney} from 'v-money'
import axios from "axios";
import { mapState } from "vuex";
import usuarioHelper from "@/helpers/usuario-logado.js";
import AdicionarItemModal from "./AdicionarItemModal";
import TabelaFipeModal from "./TabelaFipeModal";
import BotaoRecusarCotacao from "./BotaoRecusarCotacao.vue";
import ModalImportarPlanilhaItens from "./ModalImportarPlanilhaItens.vue";
import wizardCotacao from "@/helpers/wizard-cotacao.js";
import CustomFormat from '@/helpers/custom-format'
import mask from "@/helpers/mask"

export default {
  name: "GridVeiculos",
  directives: {
    money: VMoney
  },
  components: {
    AdicionarItemModal,
    TabelaFipeModal,
    BotaoRecusarCotacao,
    ModalImportarPlanilhaItens,
  },
  data() {
    return {
      statusAtualApolice: null,
      infoVeiculo: null,
      listaVeiculo: [],
      disabilitar: false,
      filtrarErros: false,
      snack: false,
      snackColor: "",
      snackText: "",
      dialog: false,
      dialogImportarPlanilha: false,
      dialogAvaliando: false,
      dialogConfirmacao: false,
      dialogFipe: false,
      pagination: {
        sortBy: "name",
      },
      selected: [],
      regras: {
        notNull: [(v) => !!v || "Você não pode deixar este campo em branco"],
      },
      filtro: {
        pesquisa: {
          opened: false,
          conteudo: "",
        },
      },
      campos: {
        listaEstados: [],
        tipoVeiculoList: [],
        catVeiculoList: [],
        ufPernoiteList: [],
        usoDoVeiculoList: [],
        propriedadeRegistroDoCrlvList: [],
        diasGarantZeroKmList: [],
        codigoSistemaRastreamentoList: [],
        tipoCoberturaList: [],
        tipoDeContratacaoList: [],
        tipoDeFranquiaList: [],
        tipoDePropostaList: [],
        ciaRenovacaoList: [],
        kmAssistenciaList: [],
        carroReservaList: [],
        descrCarroceriaList: [],
        descrEquipamentosList: [],
        descrAcessoriosList: [],
        coberturaVidrosList: [],
        classeList: new Array(11).fill({}).map((_, index) => ({
          id: index,
          titulo: `${index}`,
        })),
        renovacaoSinistroOptions: [
          {
            id: true,
            titulo: "Com sinistro",
          },
          {
            id: false,
            titulo: "Sem Sinistro",
          },
        ],
      },
      resultados: {
        totalPremio: null,
      },
      headers: [
        { text: "ITEM", align: "center", value: "item" },
        { text: "", align: "center", value: "", notSortable: true, class: "pa-0" },
        {
          text: "PLACA",
          align: "center",
          value: "placa",
        },
        { text: "CHASSI", align: "center", value: "chassi" },
        { text: "FIPE", align: "center", value: "fipe", style: "width: 100px" },
        { text: "MARCA", align: "center", value: "marca" },
        { text: "MODELO ", align: "center", value: "modelo" },
        { text: "TIPO VEÍCULO", align: "center", value: "tipoVeiculo" },
        { text: "CAT. VEÍCULO", align: "center", value: "catVeiculo" },
        { text: "ANO FAB.", align: "center", value: "anoFab" },
        { text: "ANO MOD.", align: "center", value: "anoMod" },
        { text: "UF PERNOITE", align: "center", value: "ufPernoite" },
        { text: "USO DO VEÍCULO", align: "center", value: "usoDoVeiculo" },
        {
          text: "PROPRIEDADE (REGISTRO DO CRLV)",
          align: "center",
          value: "propriedadeRegistroDoCrlv",
        },
        { text: "PROPRIETÁRIO", align: "center", value: "proprietario" },
        { text: "CPF/CNPJ", align: "center", value: "cpfCnpj" },
        { text: "NOME SOCIAL", align: "center", value: "nomeSocial" },
        { text: "CHASSI REMARCADO", align: "center", value: "chassiRemarcado" },
        { text: "ZERO KM", align: "center", value: "zeroKm" },
        { text: "SAÍDA CONCESSIONÁRIA", align: "center", value: "saidaDaConcessionaria" },
        { text: "QUANT PASSAGEIROS", align: "center", value: "quantPassageiros" },
        { text: "DISPOSITIVO DE SEGURANÇA", align: "center", value: "codigoSistemaRastreamento"},
      ],
      dadosPlanilha: [],
      idApolice: null,
      selecionarModelo: null,
      chassis: [],
      chassiQtdPassageiros: {}
    };
  },
  computed: {
    ...mapState("formCotacao", [
      "apoliceNumeroProposta",
      "id",
      "proponenteCnpj",
      "proponenteRazaoSocial",
      "dateInicio",
      "dateFim",
      "totalPremio",
      "idPropostaStatus",
    ]),

    quantidadeItens() {
      return this.$store.getters["formCotacao/quantidadeItem"];
    },
    copiaParcial() {
      return this.$store.getters["formCotacao/copiaParcial"];
    },
    copiaParcialSemItens() {
      return this.$store.getters["formCotacao/copiaParcialSemItens"];
    },
    camposDisabled() {
      if (this.idPropostaStatus > 1  && this.idPropostaStatus < 8) {
        return true
      }
      else if (this.idPropostaStatus == 7) {
        return true
      }
    },
    mostrarBotaoReavaliar() {
      if (this.selected.length !== 1) {
        return false;
      }
      return !!this.erroPlanilha[this.selected[0].item];
    },
    errosFiltrados() {
      return this.filtrarErros && this.numeroErros
        ? this.dadosPlanilha.filter((value) => value.erro)
        : this.dadosPlanilha;
    },
    numeroErros() {
      return Object.values(this.erroPlanilha).reduce(
        (acc, cur) => (cur ? acc + 1 : acc),
        0
      );
    },
    erroPlanilha() {
      return this.formatarErro(this.dadosPlanilha);
    },
    proximoIndice() {
      return (
        this.dadosPlanilha.reduce(
          (acc, cur) => (cur.item > acc ? cur.item : acc),
          -1
        ) + 1
      );
    },
    erros() {
      const validar = (ativo, temErro) => {
        if (!ativo) {
          return { ativo: false };
        }
        return {
          ativo: true,
          erro: temErro(),
        };
      };
      return this.dadosPlanilha.reduce(
        (acc, cur) => ({
          ...acc,
          [cur.item]: {
            catVeiculo: validar(
              true,
              () => !cur.catVeiculo || typeof cur.catVeiculo.id !== "number"
            ),

            ufPernoite: validar(
              true,
              () => !cur.ufPernoite || typeof cur.ufPernoite.id !== "number"
            ),

            usoDoVeiculo: validar(
              true,
              () => !cur.usoDoVeiculo || typeof cur.usoDoVeiculo.id !== "number"
            ),

            codigoSistemaRastreamento: validar(
              true,
              () => !cur.codigoSistemaRastreamento || typeof cur.codigoSistemaRastreamento.id !== "number"
            ),

            propriedadeRegistroDoCrlv: validar(
              true,
              () =>
                !cur.propriedadeRegistroDoCrlv ||
                typeof cur.propriedadeRegistroDoCrlv.id !== "number"
            ),
            fipe: {
              ativo: !(cur.catVeiculo && [6].includes(cur.catVeiculo.id)),
            }

          },
        }),
        {}
      );
    },
  },
  mounted() {
    this.statusAtualApolice = this.$route.query.idPropostaStatus ? this.$route.query.idPropostaStatus : null;
    this.idApolice = this.$route.query.id;
    const destinoWizard = wizardCotacao.proximaRotaWizard(
      wizardCotacao.ETAPAS.VEICULOS,
      this.$store.getters["formCotacao/estadoWizard"]
    );
    if (destinoWizard) {
      return this.$router.push(
        wizardCotacao.rotaWizard(destinoWizard, this.idApolice)
      );
    }
    this.carregarDadosPlanilha();
    this.buscaOpcoes();
    this.disabledItem();
  },

  methods: {

    carregarDadosPlanilha() {
      this.dadosPlanilha = this.$store.getters["formCotacao/cloneConteudoPlanilha"];
      this.chassis = this.dadosPlanilha.map(item => item.chassi);
      if (this.chassis.length) {
        this.buscarNumPassageiro(this.chassis);
      }
    },

    importarPlanilhaItens({ conteudoPlanilha, erroPlanilha }) {
      this.dialogImportarPlanilha = false;
      this.$store.commit("formCotacao/setConteudoPlanilha", {
        dados: conteudoPlanilha
      });
      this.$store.commit("formCotacao/setErroPlanilha", {
        dados: erroPlanilha
      });
      this.selected = [];
      this.carregarDadosPlanilha();
      this.disabledItem();
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Arquivo importado com sucesso";
    },

    buscarFipes() {
      this.$store.commit('startLoading');
      axios
        .get(
          `${process.env.URL_FIPEMS}/v1/consultarVeiculo?chassi=${this.selecionarModelo.chassi}&placa=${this.selecionarModelo.placa}
            `,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
            },
          }
        )
        .then( response => {
          return response.data;

        }).then(data => {
          this.listaVeiculo = data.veiculoList;
          const {agregadosII, ...info} = data;
          this.infoVeiculo = {...agregadosII, ...info};
          this.dialogFipe = true
          this.$store.commit("endLoading");

        })
        .catch((err) => {
          console.log(err);
          this.$store.commit("endLoading");
        });
    },
    disabledItem() {
      if (this.idPropostaStatus >= 3 && this.idPropostaStatus < 8) {
        return (this.disabilitar = true);
      } else {
        this.disabilitar = false;
      }
    },
    formatarErro(novosErros, listaErros = {}) {
      return {
        ...listaErros,
        ...novosErros.reduce(
          (acc, cur) => ({ ...acc, [cur.item]: cur.erro }),
          {}
        ),
      };
    },

    async buscarNumPassageiro(chassis){
      const chassiModel = {
        chassis: chassis
      }
      var response = await axios.post(
        `${process.env.URL_APOLICEMS}/v1/buscarNumeroPassageiro/`,chassiModel,
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );
      for(var agregado of response.data){
        this.chassiQtdPassageiros[agregado.nrChassi] = agregado.nrQtdPax
        for(var planilha of this.errosFiltrados){
          if(planilha.chassi === agregado.nrChassi){
          planilha.quantPassageiro = agregado.nrQtdPax
          }
        }

      }

    },

    formatarCnpj(cnpj) {
      if (typeof cnpj === "string" && cnpj.match(/^[A-Za-z0-9]{12}\d{2}$/)) {
        return cnpj.replace(
          /^(.{2})(.{3})(.{3})(.{4})(.{2})$/,
          "$1.$2.$3/$4-$5"
        );
      }
      return "";
    },
    formatarData(data) {
      if (data) {
        return new Date(data).toLocaleDateString("pt-BR", {
          timeZone: "UTC",
          year: "numeric",
          month: "numeric",
          day: "numeric",
        });
      }
    },
    formatarNumeroItem(item) {
      return typeof item === "number" ? `000000${item}`.slice(-6) : "----";
    },

    async reavaliarItem(item) {
      this.dialogAvaliando = true;
      try {
        const response = await axios.post(
          `${process.env.URL_PLANILHAMS}/v1/revalidarCamposPlanilha`,
          item,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
            },
          }
        );

        response.data.forEach((e) => {
          if (e.erro) {
            this.snack = true;
            this.snackColor = "error";
            this.snackText = "Dados inválidos.";
            return;
          }
          if (
            e.item in this.erroPlanilha &&
            e.erro !== this.erroPlanilha[e.item]
          ) {
            for (let i = 0; i < this.dadosPlanilha.length; i++) {
              if (this.dadosPlanilha[i].item === e.item) {
                this.dadosPlanilha[i].erro = e.erro;
                this.snack = true;
                this.snackColor = "success";
                this.snackText = "Dados validados com sucesso!";
                break;
              }
            }
          }
        });
      } catch (error) {
        return error;
      } finally {
        this.dialogAvaliando = false;
      }
    },

    buscarTitulo(entity, list) {
      if (entity) {
        const campo = list.find(
          (item) => item === entity.id || item.id === entity.id
        );
        if (campo) {
          return campo.titulo;
        }
      }
      return "-";
    },

    deletarItens() {
      const selecionados = this.selected.map((e) => e.item);
      this.dadosPlanilha = this.dadosPlanilha.filter(
        (e) => !selecionados.includes(e.item)
      );
    },

    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.dadosPlanilha.slice();
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    save() {
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Item salvo";
    },

    saveErro(item) {
      this.save();
      item.erro = true;
    },

    cancel() {
      this.snack = true;
      this.snackColor = "error";
      this.snackText = "Editar cancelado";
    },
    open() {
      this.snack = true;
      this.snackColor = "info";
      this.snackText = "Editar aberto";
    },
    close() {
      console.log("Dialog closed");
    },
    filtroFunctions: function () {
      const self = this;
      return {
        abrirFiltroPesquisa: function () {
          self.filtro.pesquisa.opened = true;
        },
        fecharFiltroPesquisa: function () {
          if (
            !self.filtro.pesquisa.conteudo ||
            self.filtro.pesquisa.conteudo == ""
          ) {
            self.filtro.pesquisa.opened = false;
          }
        },
      };
    },

    buscaOpcoes() {
      axios
        .get(`${process.env.URL_PLANILHAMS}/v1/buscarOpcoesCampos/`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
          },
        })
        .then((response) => {
          [
            "tipoVeiculoList",
            "catVeiculoList",
            "ufPernoiteList",
            "usoDoVeiculoList",
            "propriedadeRegistroDoCrlvList",
            "diasGarantZeroKmList",
            "tipoCoberturaList",
            "tipoDeContratacaoList",
            "tipoDeFranquiaList",
            "tipoDePropostaList",
            "ciaRenovacaoList",
            "kmAssistenciaList",
            "carroReservaList",
            "descrCarroceriaList",
            "descrEquipamentosList",
            "descrAcessoriosList",
            "coberturaVidrosList",
            "codigoSistemaRastreamentoList",
          ].forEach((nome) => {
            this.campos[nome] =
              response.data[nome] instanceof Array ? response.data[nome] : [];
          });
        })
        .catch((err) => {
          console.error(err);
        });
    },

    traduzValor(value) {
      if (value === true) {
        return (value = "Sim");
      } else {
        return (value = "Não");
      }
    },

    validaColunas() {
      return Object.values(this.erros).every((item) =>
        Object.values(item).every((subItem) => subItem.erro !== true)
      );
    },

    voltar: function () {
      if (this.$route.query.apoliceCopiada == "true") {
        this.$router.push(`/GridPrincipal/Risco?id=${this.idApolice}&apoliceCopiada=${true}${this.statusAtualApolice ? `&idPropostaStatus=${this.statusAtualApolice}` : ''}`);
      } else if(this.$route.query.apoliceRenovacao) {
        this.$router.push(`/GridPrincipal/Risco?id=${this.idApolice}&apoliceRenovacao=${true}${this.statusAtualApolice ? `&idPropostaStatus=${this.statusAtualApolice}` : ''}`);
      } else {
        this.$router.push(
          `/GridPrincipal/Risco${this.idApolice ? `?id=${this.idApolice}` : ''}${this.statusAtualApolice ? `&idPropostaStatus=${this.statusAtualApolice}` : ''}`
        );
      }
    },
    proximo() {
      const dadosAtualizados = {
        dados: this.dadosPlanilha,
      };

      /* Lógica para verificar se há chassi duplicado */
      this.chassis.length = 0;

      for(var chassi of dadosAtualizados.dados){
        this.chassis.push(chassi.chassi)
      }

      const chassisRepetidos = this.chassis.filter((e, i, a) => a.indexOf(e) !== i);

      if (chassisRepetidos.length > 0) {
        this.snack = true;
        this.snackColor = "error";
        this.snackText = `Erro no chassi: ${chassisRepetidos[0]}. Possui um ou mais itens com o mesmo chassi.`;
        return;
      }
      /* -------------------------------------------- */

      /* Verifica se o campo Modelo tem mais de 65 caracteres */
      for (var item of dadosAtualizados.dados) {
        if (item.modelo.length > 65) {
        this.snack = true;
        this.snackColor = "error";
        this.snackText = `[Erro no item ${item.item}] O campo 'Modelo' não pode ultrapassar os 65 caracteres.`;
        return;
        }
      }
      /* -------------------------------------------- */

      this.$store.commit("formCotacao/setConteudoPlanilha", dadosAtualizados);

      if (this.$route.query.apoliceCopiada == "true") {
        this.$router.push(`/GridPrincipal/Cobertura?id=${this.idApolice}&apoliceCopiada=${true}${this.statusAtualApolice ? `&idPropostaStatus=${this.statusAtualApolice}` : ''}`);
      } else if(this.$route.query.apoliceRenovacao) {
        this.$router.push(`/GridPrincipal/Cobertura?id=${this.idApolice}&apoliceRenovacao=${true}${this.statusAtualApolice ? `&idPropostaStatus=${this.statusAtualApolice}` : ''}`);
      }
      else {
        this.$router.push(
          `/GridPrincipal/Cobertura${this.idApolice ? `?id=${this.idApolice}` : ''}${this.statusAtualApolice ? `&idPropostaStatus=${this.statusAtualApolice}` : ''}`
        );
      }
    },

    exibeFipe(item) {

      item.dcRetorno = item.dcRetorno == undefined ? null : item.dcRetorno;
      if (item.dcRetorno === null) {
        this.selecionarModelo = item;
        this.buscarFipes();
      } else {
        this.snack = true;
        this.snackColor = "error";
        this.snackText = item.dcRetorno;
        return;
      }
    },

    comparador(itemLista, item) {
      if (item && item.id) {
        return item.id === itemLista.id;
      }
      return false;
    },

    formatarNumeroCotacao(item) {
      if (item != null) {
        const numero = `000000${item}`;
        return numero.slice(numero.length - 6);
      }
    },
    formatarNumeroApolice(item) {
      if (item != null) {
        return item;
      }
    },

    async preencherDadosVeiculo(veiculoSelecionado, infoVeiculo) {
      if (veiculoSelecionado && veiculoSelecionado.codigoFipe) {
        this.selecionarModelo.fipe = veiculoSelecionado.codigoFipe;
        this.selecionarModelo.modelo = veiculoSelecionado.modelo;
        this.selecionarModelo.anoMod = veiculoSelecionado.anoModelo;
        this.selecionarModelo.marca = veiculoSelecionado.marca;
        this.selecionarModelo.tipoVeiculo = veiculoSelecionado.tipoVeiculo;
        this.selecionarModelo.chassi = infoVeiculo.chassi;
        this.selecionarModelo.placa = infoVeiculo.placa;
        await this.reavaliarItem([this.selecionarModelo]);
        this.selecionarModelo = null;
        this.dialogFipe = false;
      }
    },
  },
};
</script>

<style>
  .background {
    background-color: white;
  }

  .table-width > div > div > table {
    width: 3000px;
  }

  .item-color > div > a {
    color: #757575 !important;
  }

  .activeError {
    border: 1px solid red;
    color: red !important;
  }

  .button-permanecer {
    background: #00456e;
    color: white !important;
  }

  .text-permanecer {
    font-weight: bold;
    color: #757575 !important;
  }

  .errorTaxa {
    color: red !important;
    font-weight: bold;
  }

  .text-align-center {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/frota/GridVeiculos.vue